// extracted by mini-css-extract-plugin
export default {"control":"NavbarLinksGroup_control__5HG-O","link":"NavbarLinksGroup_link__YY1kI","chevron":"NavbarLinksGroup_chevron__T4TW0"};